import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActionModalComponent } from './action-modal/action-modal.component';
import { CohortReleaseSearchComponent } from './cohort-release-search/cohort-release-search.component';
import { CollapsiblePanelComponent } from './collapsible-panel/collapsible-panel.component';
import { ContentWithLabelComponent } from './content-with-label/content-with-label.component';
import { HeaderAndValueComponent } from './header-and-value/header-and-value.component';
import { ModuleSearchComponent } from './module-search/module-search.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { PageTitleComponent } from './page-title/page-title.component';
import { SpacerComponent } from './spacer/spacer.component';
import { StatusIndicatorComponent } from './status-indicator/status-indicator.component';

@NgModule({
  declarations: [
    ActionModalComponent,
    CohortReleaseSearchComponent,
    CollapsiblePanelComponent,
    ContentWithLabelComponent,
    HeaderAndValueComponent,
    ModuleSearchComponent,
    NavBarComponent,
    PageTitleComponent,
    SpacerComponent,
    StatusIndicatorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbTypeaheadModule,
    NgSelectModule,
    RouterModule,
  ],
  exports: [
    ActionModalComponent,
    CohortReleaseSearchComponent,
    CollapsiblePanelComponent,
    ContentWithLabelComponent,
    HeaderAndValueComponent,
    ModuleSearchComponent,
    NavBarComponent,
    PageTitleComponent,
    SpacerComponent,
    StatusIndicatorComponent,
  ],
})
export class SharedModule {}
